import { render, staticRenderFns } from "./weekendPart.vue?vue&type=template&id=921bef90&scoped=true&"
import script from "./weekendPart.vue?vue&type=script&lang=js&"
export * from "./weekendPart.vue?vue&type=script&lang=js&"
import style0 from "./weekendPart.vue?vue&type=style&index=0&id=921bef90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921bef90",
  null
  
)

export default component.exports